import { EarningMechanismTypename } from './earning-mechanism.types';

export const EarningMechanismWithProgressTypenames: EarningMechanismTypename[] = [
  'EarningMechanismVisits',
  'EarningMechanismTotalSpendOverTime',
  'EarningMechanismTotalEligiblePurchaseOverTime',
  'EarningMechanismVarietyPurchaseOverTime',
];
